<template>
    <div class="btn-create-v2" v-click-outside="close">
        <BmvButton
            :icon="'fal fa-plus'"
            :icon-right="open ? 'fal fa-chevron-up' : 'fal fa-chevron-down'"
            size="sm"
            @click="open = !open"
        >
            <span class="btn-create-v2-label">{{ $t('topbar.new') }}</span>
        </BmvButton>
        <div v-if="open" class="btn-create-v2-menu" role="menu">
            <router-link
                to="/post/create/forms"
                class="btn-create-v2-item"
                @click.native="close"
            >
                <i class="fal fa-ticket"></i>
                <span>{{ $t('topbar.ticket') }}</span>
            </router-link>
            <router-link
                to="/forms/builder"
                class="btn-create-v2-item"
                @click.native="close"
            >
                <i class="fal fa-poll"></i>
                <span>{{ $t('topbar.form') }}</span>
            </router-link>
            <router-link
                to="/admin/template/create"
                class="btn-create-v2-item"
                @click.native="close"
            >
                <i class="fal fa-file-alt"></i>
                <span>{{ $t('topbar.template') }}</span>
            </router-link>

            <template v-if="canCreateUsers">
                <div class="btn-create-v2-divider"></div>
                <router-link
                    to="/company/user/create"
                    class="btn-create-v2-item"
                    @click.native="close"
                >
                    <i class="fal fa-user-tie"></i>
                    <span>{{ $t('topbar.user') }}</span>
                </router-link>
                <router-link
                    to="/company/citizens/create"
                    class="btn-create-v2-item"
                    @click.native="close"
                >
                    <i class="fal fa-user-plus"></i>
                    <span>{{ $t('topbar.citizen') }}</span>
                </router-link>
            </template>
        </div>
    </div>
</template>

<script>
/**
 * SPDX-FileCopyrightText: © 2021-2026 SAS Cœur du Web, Paris (France) — https://coeurduweb.com
 * SPDX-License-Identifier: LicenseRef-CoeurDuWeb-Proprietary
 *
 * Tous droits réservés. Logiciel propriétaire, non libre.
 * Les conditions d'utilisation, le périmètre de la licence concédée et les
 * restrictions applicables figurent dans le fichier LICENCE.md à la racine du dépôt.
 */
import BmvButton from '@/components/UI/v2/BmvButton.vue'

export default {
    name: 'ButtonCreateV2',
    components: { BmvButton },
    directives: {
        'click-outside': {
            bind(el, binding) {
                el._clickOutside = (e) => {
                    if (!el.contains(e.target)) binding.value()
                }
                document.addEventListener('mousedown', el._clickOutside)
            },
            unbind(el) {
                document.removeEventListener('mousedown', el._clickOutside)
            }
        }
    },
    data() {
        return { open: false }
    },
    computed: {
        // Both routes are guarded by users.create — don't offer a dead link.
        canCreateUsers() {
            const permissions = this.$store.state.auth.permissions || []
            return permissions.includes('users.create')
        }
    },
    methods: {
        close() {
            this.open = false
        }
    }
}
</script>

<style scoped>
.btn-create-v2 {
    position: relative;
}

.btn-create-v2-label {
    display: none;
}

@media (min-width: 640px) {
    .btn-create-v2-label {
        display: inline;
    }
}

.btn-create-v2-menu {
    position: absolute;
    top: calc(100% + 6px);
    right: 0;
    min-width: 200px;
    background: var(--v2-surface-0);
    border: 1px solid var(--v2-border);
    border-radius: var(--v2-radius-lg);
    box-shadow: var(--v2-shadow-lg);
    padding: 4px;
    z-index: 40;
    font-family: var(--v2-font-sans);
}

.btn-create-v2-item {
    display: flex;
    align-items: center;
    gap: var(--v2-space-3);
    padding: 8px var(--v2-space-3);
    border-radius: var(--v2-radius-sm);
    color: var(--v2-text-2);
    font-size: var(--v2-text-sm-size);
    text-decoration: none;
    transition: background var(--v2-transition-fast),
        color var(--v2-transition-fast);
}

.btn-create-v2-item:hover {
    background: var(--v2-primary-soft);
    color: var(--v2-primary);
}

.btn-create-v2-item i {
    width: 18px;
    font-size: 0.9rem;
    flex-shrink: 0;
    color: var(--v2-text-4);
}

.btn-create-v2-item:hover i {
    color: var(--v2-primary);
}

.btn-create-v2-divider {
    height: 1px;
    margin: 4px 6px;
    background: var(--v2-border);
}
</style>
